export default __webpack_public_path__ + "static/media/content-cover.91d5d417.png";